module.exports = __webpack_public_path__ + "static/intertec_screen_7-6be0657b3e6c5637156bd34033731fec.avif";